import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { InventarioService } from './inventario.service';
import { EtapaEstrutura } from './models/inventario';




@Injectable({ providedIn: 'root'})
export class EtapaEstruturaResolver implements Resolve<Observable<EtapaEstrutura[]>>{

    constructor(private inventarioService: InventarioService) {}

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        const idEtapa = route.params.idEtapa;
        return this.inventarioService.getEtapaEstrutura(idEtapa);
    }

}